import * as React from 'react'
import { Badge } from './badge'
import { cn } from '../../lib/cn'

const STATUS_TONE_BY_CODE = {
  COMPLETED: 'success',
  SUCCESS: 'success',
  DONE: 'success',
  APPROVED: 'success',
  ACTIVE: 'success',
  ON_DUTY: 'success',

  IN_PROGRESS: 'info',
  PROCESSING: 'info',
  RUNNING: 'info',
  ASSIGNED: 'info',
  SENT: 'info',
  SUBMITTED: 'info',

  RECEIVED: 'warning',
  PENDING: 'warning',
  WAITING: 'warning',
  WAITING_AUTH: 'warning',
  RE_REQUESTED: 'warning',
  NEEDS_REVIEW: 'warning',
  DRAFT: 'warning',

  FAILED: 'danger',
  ERROR: 'danger',
  REJECTED: 'danger',
  CANCELLED: 'danger',
  CANCELED: 'danger',
  EXPIRED: 'danger',
  SUSPENDED: 'danger',
}

function statusTone(status, fallback = 'neutral') {
  const code = String(status || '').trim().toUpperCase()
  return STATUS_TONE_BY_CODE[code] || fallback
}

const STATUS_DOT_CLASS_BY_TONE = {
  success: 'bg-sgez-success',
  warning: 'bg-sgez-warning',
  info: 'bg-sgez-info',
  danger: 'bg-sgez-danger',
  neutral: 'bg-slate-400',
}

const STATUS_A11Y_BY_TONE = {
  success: '정상 또는 완료 상태',
  warning: '확인 또는 대기 상태',
  info: '진행 또는 안내 상태',
  danger: '오류 또는 위험 상태',
  neutral: '일반 상태',
}

function StatusBadge({
  status,
  label,
  tone,
  children,
  withDot = true,
  className,
  title,
  ...props
}) {
  const resolvedTone = tone || statusTone(status)
  const content = children || label || status || '-'
  const resolvedTitle = title || STATUS_A11Y_BY_TONE[resolvedTone] || STATUS_A11Y_BY_TONE.neutral

  return (
    <Badge
      variant={resolvedTone}
      className={cn('gap-1.5 rounded-full px-2.5 py-1 font-medium', className)}
      title={resolvedTitle}
      {...props}
    >
      {withDot && (
        <span
          aria-hidden="true"
          className={cn('h-1.5 w-1.5 rounded-full', STATUS_DOT_CLASS_BY_TONE[resolvedTone] || STATUS_DOT_CLASS_BY_TONE.neutral)}
        />
      )}
      <span>{content}</span>
    </Badge>
  )
}

export { StatusBadge, statusTone }
